<div
  class="
    ui
    fixed-menu
    basic
    attached
    no
    border
    shadow
    sticky
    bottom
    fixed
    footer
    small
    computer-hidden
    fitted
    segment
  "
>
  <div
    class="ui fluid {{
      menuItemLength
    }}  no shadow border item compact labeled icon mini menu "
  >
    <ng-container *ngFor="let item of menuItem">
      <a
        class="item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="item.link"
      >
        <i class="{{ item.icon }} icon"></i>
        <span>{{ item.name }}</span>
      </a>
    </ng-container>
  </div>
</div>
